import { render, staticRenderFns } from "./CUEntryForm.vue?vue&type=template&id=1bc1d4e5&scoped=true"
import script from "./CUEntryForm.vue?vue&type=script&lang=js"
export * from "./CUEntryForm.vue?vue&type=script&lang=js"
import style0 from "./CUEntryForm.vue?vue&type=style&index=0&id=1bc1d4e5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bc1d4e5",
  null
  
)

export default component.exports